<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>S.K. Benz believes story is not written with a pen; it comes from the heart, guided by the soul. Every word symbolises aliveness, drawn on the paper that gives virtue of love to whoever reads it. We call it creativity. Benz constantly desired to tell stories, but something was always a miss; then one day magic happened. She fell in love with life which was the missing piece of the puzzle for loving life is the most serene experience. She hopes that every word you read fills your life with love and joy!!!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7ab88ce6